<app-table
  [options]="tableOptions"
  [columnsTemplates]="{
    isEnabled: statusTmp
  }"
  (onInitialized)="onInitTable($event)"
  (onSelectionChanged)="onSelectionChanged($event)"
></app-table>

<ng-template #statusTmp let-value="value">
  <users-status [value]="value"></users-status>
</ng-template>
